import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import api from '../../services/api';
import MapaLeaflet from '../mapa/MapaLeaflet';
import { horaTexto } from '../../utils/ordenes';

// Mapa de un día (29-oct-2026, Portal Empresa → Clientes → Mapa): las visitas agendadas ese día en el orden
// que sigue el técnico, numeradas y unidas. Sin km ni tiempos de viaje (eso lo ve solo el admin).
const COLOR = { HECHO: '#16A34A', EN_CURSO: '#2563EB', AGENDADO: '#C9341F' };

export default function MapaDiaEmpresa({ dia, salida = null, onAbrirPedido }) {
    const [sel, setSel] = useState(null);
    const visitas = dia.visitas || [];
    const conPos = visitas.filter(v => v.lat != null);
    // Desde dónde arranca el técnico (S), y de ahí al 1, al 2…
    const inicio = salida?.lat != null ? [{ id: 'salida', lat: salida.lat, lng: salida.lng, color: '#111827', etiqueta: 'S', titulo: 'Sale de acá', tituloFijo: true }] : [];
    const abrir = async (id) => {
        try { const r = await api.get(`/empresa/pedidos/${id}`); onAbrirPedido(r.data); } catch { toast.error('No se encontró el pedido'); }
    };
    const puntos = [...inicio, ...conPos.map(v => ({
        id: v.id, lat: v.lat, lng: v.lng, color: COLOR[v.estado] || COLOR.AGENDADO,
        etiqueta: String(visitas.indexOf(v) + 1), titulo: v.lugar || v.direccion,
    }))];
    const v = visitas.find(x => x.id === sel);
    return (
        <div className="relative isolate rounded-2xl overflow-hidden border border-black/[0.06] dark:border-white/[0.06]">
            <MapaLeaflet puntos={puntos} seleccionado={sel} lineas={[...inicio, ...conPos].map(x => [x.lat, x.lng])} ajustarKey={`dia-${dia.fecha}`}
                onClickPunto={p => p.id !== 'salida' && setSel(p.id)} onClickMapa={() => setSel(null)}
                className="w-full h-[calc(var(--vh,1vh)*100-360px)] min-h-[340px]" />
            {conPos.length < visitas.length && (
                <span className="absolute top-3 right-3 z-[500] h-8 px-3 rounded-full bg-card shadow text-caption font-bold text-secondary inline-flex items-center">
                    {visitas.length - conPos.length} sin ubicar
                </span>
            )}
            {v && (
                <div className="absolute left-3 right-3 bottom-3 z-[600] p-3.5 rounded-2xl bg-card shadow-xl flex items-center gap-3">
                    <span className="w-8 h-8 shrink-0 rounded-full text-white text-label font-black inline-flex items-center justify-center" style={{ background: COLOR[v.estado] || COLOR.AGENDADO }}>{visitas.indexOf(v) + 1}</span>
                    <span className="flex-1 min-w-0">
                        <span className="block text-body font-black text-ink truncate">{v.lugar || v.direccion}</span>
                        <span className="block text-caption text-muted truncate">{[v.hora && horaTexto(v.hora), v.tarea, v.estado === 'HECHO' ? 'Hecho' : null].filter(Boolean).join(' · ')}</span>
                    </span>
                    {v.pedidoId && onAbrirPedido && (
                        <button type="button" onClick={() => abrir(v.pedidoId)} className="h-10 px-3 shrink-0 rounded-xl bg-chip text-label font-black text-ink">Ver pedido</button>
                    )}
                </div>
            )}
        </div>
    );
}
